"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var Drawer_1 = __importDefault(require("./components/Drawer"));
var CreateUrlModal_1 = __importDefault(require("./components/CreateUrlModal"));
var AnnouncementModal_1 = __importDefault(require("./components/AnnouncementModal"));
var actions_1 = __importDefault(require("./actions"));
var BaseLayout_1 = __importDefault(require("../app/components/BaseLayout"));
var UserLinkTable_1 = __importDefault(require("./components/UserLinkTable"));
var EmptyState_1 = __importDefault(require("./components/EmptyState"));
var isFiltered_1 = __importDefault(require("./components/EmptyState/isFiltered"));
var actions_2 = __importDefault(require("../login/actions"));
var ga_1 = require("../app/util/ga");
/**
 * Show the user page.
 */
var UserPage = function () {
    var fetchingUrls = react_redux_1.useSelector(function (state) { return state.user.isFetchingUrls; });
    var urlCount = react_redux_1.useSelector(function (state) { return state.user.urlCount; });
    var message = react_redux_1.useSelector(function (state) { return state.user.message; });
    var isLoggedIn = react_redux_1.useSelector(function (state) { return state.login.isLoggedIn; });
    var emailValidator = react_redux_1.useSelector(function (state) { return state.login.emailValidator; });
    var dispatch = react_redux_1.useDispatch();
    var getUrlsForUser = function () { return dispatch(actions_1.default.getUrlsForUser()); };
    var getEmailValidator = function () {
        return dispatch(actions_2.default.getEmailValidationGlobExpression());
    };
    var getUserMessage = function () { return dispatch(actions_1.default.getUserMessage()); };
    var urlsFiltered = isFiltered_1.default();
    react_1.useEffect(function () {
        if (isLoggedIn) {
            getUrlsForUser();
            if (!emailValidator) {
                getEmailValidator();
            }
            if (message === null) {
                getUserMessage();
            }
        }
    }, [isLoggedIn]);
    react_1.useEffect(function () {
        if (isLoggedIn) {
            // Google Analytics: User page, to record sign in - act as exit for otp, devices, clicks and traffic page
            ga_1.GAPageView('USER PAGE');
            ga_1.GAEvent('user page', 'main');
        }
    }, [isLoggedIn]);
    if (isLoggedIn) {
        return (react_1.default.createElement(BaseLayout_1.default, null,
            react_1.default.createElement(Drawer_1.default, null,
                !fetchingUrls && urlCount === 0 && !urlsFiltered ? (react_1.default.createElement(EmptyState_1.default, { urlsFiltered: urlsFiltered })) : (react_1.default.createElement(UserLinkTable_1.default, null)),
                react_1.default.createElement(CreateUrlModal_1.default, null),
                react_1.default.createElement(AnnouncementModal_1.default, null))));
    }
    return react_1.default.createElement("div", null);
};
exports.default = UserPage;
